import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


function createData(empCode, empName, grossSalary, professionTax) {
  return { empCode, empName, grossSalary, professionTax };
}

const rows = [
  createData(123, 'Ankur Kumar', 7500, 0.00),
];

export default function PTReportTable() {
  return (
    <TableContainer component={Paper} style={{marginBottom: "20px"}}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Employee Code</TableCell>
            <TableCell align="left">Employee Name</TableCell>
            <TableCell align="right">Gross Salary</TableCell>
            <TableCell align="right">Profession Tax</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.empCode}
              </TableCell>
              <TableCell align="left">{row.empName}</TableCell>
              <TableCell align="right">{row.grossSalary}</TableCell>
              <TableCell align="right">{row.professionTax}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
